import api from "./index";
import { OfferApplicationCreate } from "../models/offerApplications";

const BASE = '/applications';

export const createApplication = async (claimData: OfferApplicationCreate) => {
    try {
        const response = await api.post(`${BASE}/create`, claimData);
        return response.data;
    } catch (error) {
        console.error('Failed to create application:', error);
        throw error;
    }
};

export const getAllApplications = async (params = {}) => {
    try {
        const response = await api.get(`${BASE}/getall`, { params });
        return response.data;
    } catch (error) {
        console.error('Failed to fetch applications:', error);
        throw error;
    }
};

export const deleteApplication = async (offer_id: number) => {
    try {
        const response = await api.delete(`${BASE}/delete/${offer_id}`);
        return response.data;
    } catch (error) {
        console.error('Failed to delete applicaiton offer:', error);
        throw error;
    }
};


export const checkApplication = async (offer_id: number) => {
    try {
        const response = await api.get(`${BASE}/check/${offer_id}`);
        return response.data;
    } catch (error) {
        console.error('Failed to check applicaiton offer:', error);
        throw error;
    }
};